import React from 'react';
import './index.sass';
import {ReactComponent as Map} from './icons/map.svg';
import classNames from "classnames";
import Avatar from './icons/avatar.svg';


const Ability = ({isActive, regions}) => {

    return (
        <section className={classNames({
            'Ability': true,
            'Ability--Active': isActive
        })} id="ability">
            <div className="Ability__Aura" aria-hidden="true" />
            <div className="Ability__Container container container--slim">
                <div className="Ability__Content">
                    <span className="Ability__Eyebrow">География присутствия</span>
                    <h2 className="Ability__Title">
                        Команды <span className="Text-Accent">в нескольких часовых поясах</span>
                    </h2>
                    <p className="Ability__Text">
                        Распределённые производственные центры по часовым поясам увеличивают скорость
                        разработки сложных систем, не снижая качества. Пока одна команда уходит на отдых —
                        другая продолжает. Проект движется непрерывно.
                    </p>
                    <div className="Ability__Points">
                        <div className="Ability__Point">
                            <span className="Ability__Point-Icon" />
                            <span>Региональные центры разработки</span>
                        </div>
                        <div className="Ability__Point">
                            <span className="Ability__Point-Icon" />
                            <span>Круглосуточный цикл поставки</span>
                        </div>
                        <div className="Ability__Point">
                            <span className="Ability__Point-Icon" />
                            <span>Единые стандарты качества</span>
                        </div>
                    </div>
                </div>
                <div className={classNames({
                    'Ability__Map': true,
                    'Ability__Map--1': regions >= 1,
                    'Ability__Map--2': regions >= 2,
                    'Ability__Map--3': regions >= 3,
                    'Ability__Map--4': regions >= 4,
                    'Ability__Map--5': regions >= 5,
                    'Ability__Map--6': regions >= 6,
                    'Ability__Map--7': regions >= 7,
                })}>
                    <Map/>
                    <img src={Avatar} className="Ability__Avatar Ability__Avatar--1" alt="Команда-1"/>
                    <img src={Avatar} className="Ability__Avatar Ability__Avatar--2" alt="Команда-2"/>
                    <img src={Avatar} className="Ability__Avatar Ability__Avatar--3" alt="Команда-3"/>
                    <img src={Avatar} className="Ability__Avatar Ability__Avatar--4" alt="Команда-4"/>
                    <img src={Avatar} className="Ability__Avatar Ability__Avatar--5" alt="Команда-5"/>
                    <img src={Avatar} className="Ability__Avatar Ability__Avatar--6" alt="Команда-6"/>
                    <img src={Avatar} className="Ability__Avatar Ability__Avatar--7" alt="Команда-7"/>
                </div>
            </div>
        </section>
    );
};

export default Ability;
